import { useEffect, useState } from 'react';
import { Grid, Typography, Box, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextInput, Dropdown } from 'qubCommon/Inputs';
import { useMe } from 'hooks/useMe';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import ReCAPTCHAPolicy from 'ui-component/recaptchaPolicy';
import { obscureText } from 'utils/obscureText';

const PaymentSubmittionForm = ({ readOnly, data }) => {
    const { t } = useTranslation();
    const { whoami } = useMe();
    const { reset } = useFormContext();
    const signedInUserEmail = whoami?.email;
    const email = data?.Email ?? signedInUserEmail;
    // useEffect(() => {
    //     const signedInUserEmail = whoami?.email;

    //     // If data object is not null, then use the data object to populate the form
    //     const email = data?.Email ?? signedInUserEmail;

    //     if (data) {
    //         console.log('reset', data);
    //         reset({
    //             email: whoami ? email : obscureText(email)
    //             // ,
    //             // phoneCode: data?.PhoneCode,
    //             // billCountry: data?.BillCountry,
    //             // billCity: data?.BillCity,
    //             // billAddress: data?.BillAddress,
    //             // billZip: data?.BillZip
    //         });
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [data]);

    return (
        <Box sx={{ boxShadow: 2, p: 2, borderRadius: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" fontSize="16px">
                        {t('BillingInfo')}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        disabled={readOnly}
                        label={t('Email')}
                        id="email"
                        name="email"
                        placeholder={t('Email')}
                        defaultValue={whoami ? email : obscureText(email)}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Dropdown
                        id="phoneCode"
                        name="phoneCode"
                        label={t('PhoneCode')}
                        defaultValue={data?.PhoneCode || ''}
                        options={data?.PhoneCodes}
                        textFieldProps={{
                            disabled: readOnly
                        }}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput disabled={readOnly} label={t('Phone')} id="phone" name="phone" placeholder={t('Phone')} size="medium" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Dropdown
                        id="billCountry"
                        name="billCountry"
                        label={t('BillCountry')}
                        defaultValue={data?.BillCountry || ''}
                        options={data?.Countries}
                        textFieldProps={{
                            disabled: readOnly
                        }}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        disabled={readOnly}
                        label={t('BillCity')}
                        id="billCity"
                        name="billCity"
                        placeholder={t('BillCity')}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        disabled={readOnly}
                        label={t('BillAddress')}
                        id="billAddress"
                        name="billAddress"
                        placeholder={t('billAddress')}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        disabled={readOnly}
                        label={t('BillZip')}
                        id="billZip"
                        name="billZip"
                        placeholder={t('billZip')}
                        size="medium"
                    />
                </Grid>

                <Grid item xs={12} md={12}>
                    <ReCAPTCHAPolicy />
                </Grid>
            </Grid>
        </Box>
    );
};

PaymentSubmittionForm.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    data: PropTypes.object
};

export default PaymentSubmittionForm;
